import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import { ProcessSignalName } from "Api/adminAgent/types/ProcessSignal.enum";
import Button from "ds/Button";
import * as Dialog from "ds/Modal";
import { useCloseProcessActionModal } from "Reducers/serviceProcesses/hooks/useCloseProcessActionModal";
import { useGetServiceProcesses } from "Reducers/serviceProcesses/hooks/useGetServiceProcesses";
import { useSendServiceProcessesSignal } from "Reducers/serviceProcesses/hooks/useSendServiceProcessesSignal";
import { selectServicesProcessesModal } from "Reducers/serviceProcesses/serviceProcesses.selectors";
import { Status } from "Reducers/types";
import { useAppSelector } from "Store/hooks";

import * as S from "./OptionsDialog.styles";

export const OptionsDialog = () => {
  const { formatMessage } = useIntl();
  const { isOpen, signal, process, status } = useAppSelector(
    selectServicesProcessesModal
  );
  const closeProcessActionModal = useCloseProcessActionModal();
  const sendServiceProcessesSignal = useSendServiceProcessesSignal();
  const getServiceProcesses = useGetServiceProcesses();

  const onSendSignal = async () => {
    await sendServiceProcessesSignal(process!, signal);
    closeProcessActionModal();
    getServiceProcesses();
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={() => closeProcessActionModal()}>
      <Dialog.Portal>
        <S.CustomOverlay />

        <Dialog.Content
          width={480}
          onOpenAutoFocus={e => e.preventDefault()}
          onPointerDownOutside={() => closeProcessActionModal()}
        >
          <Dialog.Close asChild>
            <Dialog.CloseButton onClick={() => closeProcessActionModal()} />
          </Dialog.Close>

          <Typography.Title tag="h3">
            {formatMessage(
              {
                id: "services.process.options.modal.title"
              },
              {
                signalName: ProcessSignalName[signal]
              }
            )}
          </Typography.Title>

          <Typography.BodyText>
            {formatMessage(
              {
                id: "services.process.options.modal.description"
              },
              {
                signalName: <b>{ProcessSignalName[signal]}</b>,
                process: (
                  <b>
                    <br />
                    {process?.name}({process?.pid})
                  </b>
                )
              }
            )}
          </Typography.BodyText>

          <S.ButtonWrapper>
            <Button
              analyticId="cancel"
              variant="secondary"
              onClick={() => closeProcessActionModal()}
            >
              {formatMessage({ id: "cancel" })}
            </Button>

            <Button
              analyticId="services.process.options.modal.continue"
              type="submit"
              disabled={status === Status.Loading}
              onClick={onSendSignal}
            >
              {formatMessage({ id: "services.process.options.modal.continue" })}
            </Button>
          </S.ButtonWrapper>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
